import { FC, useMemo } from 'react';
import styles from './styles.module.scss';
import Typography from '@components/common/typography';
import { getFirstLetter } from '@utils/index';
import { useSettingsModals } from '@hooks/modals/useSettingsModals';
import { useUserContext } from '@hooks/context/useUserContext';
import { EUserType } from '@xeppt/xeppt-sdk/types';
import Button from '@components/common/button';
import { Icon } from '@components/icons';
import { useLocales } from '@hooks/helpers/useLocales';

interface IProps {
    type: 'user' | 'business';
}

const AvatarSection: FC<IProps> = ({ type }) => {
    const { user, businessData, handleLogout } = useUserContext();
    const { handleChangeAvatar } = useSettingsModals();
    const { submitLocale } = useLocales();

    const renderAbbreviate = useMemo(() => {
        switch (type) {
            case 'user':
                return (
                    <>
                        {getFirstLetter(user?.profile?.first_name)}
                        {getFirstLetter(user?.profile?.last_name)}
                    </>
                );
            case 'business':
                return getFirstLetter(businessData?.company_name);
        }
    }, [type, user, businessData]);

    const userAvatar = useMemo(() => user?.profile?.avatar, [user]);
    return (
        <div className={styles.avatar_container}>
            <div className={styles.avatar}>
                {!!userAvatar ? (
                    <img src={userAvatar} alt="your avatar" />
                ) : (
                    <Typography variant="h3">{renderAbbreviate}</Typography>
                )}
                <div className={styles.action} onClick={handleChangeAvatar}>
                    <Icon name={!!userAvatar ? 'edit' : 'camera'} />
                </div>
            </div>
            <div className={styles.text_wrapper}>
                <p className={styles.title}>
                    {user?.profile?.first_name} {user?.profile?.last_name}
                </p>
                <p className={styles.description}>
                    {user?.type === EUserType.BUSINESS
                        ? 'Your business account'
                        : 'Your personal account'}
                </p>
            </div>
            <Button variant="text-red" leftIcon="logout" onClick={handleLogout}>
                {submitLocale('sign_out')}
            </Button>
        </div>
    );
};

export default AvatarSection;
